export default {
	getGlobalPosts(state) {
		return state.globalPosts;
	},
	getLeaguePosts(state) {
		return state.leaguePosts;
	},
	getTeamPosts(state) {
		return state.teamPosts;
	},
};